import { lng as de } from "./de.language";
import { lng as en } from "./en.language";
export const CoreLanguages: object = { "de": de, "en": en };
